import { useState } from "react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { CrosslistSubnav, PageIntro } from "@/components/SellerToolsNav";

const CHANNELS = [
  { id: "generic", name: "All headers" },
  { id: "ebay", name: "eBay File Exchange" },
  { id: "etsy", name: "Etsy" },
  { id: "amazon", name: "Amazon" },
  { id: "amazon_in", name: "Amazon.in" },
  { id: "walmart", name: "Shopify" },
  { id: "meesho", name: "Meesho" },
  { id: "flipkart", name: "Flipkart" },
  { id: "myntra", name: "Myntra" },
  { id: "ajio", name: "AJIO" },
  { id: "nykaa", name: "Nykaa Fashion" },
  { id: "tatacliq", name: "Tata CLiQ" },
];

export default function ExportCsv() {
  const [channel, setChannel] = useState("generic");
  const [allInv, setAllInv] = useState(true);
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [busy, setBusy] = useState(false);

  const generate = async () => {
    setBusy(true);
    try {
      const params = new URLSearchParams({ channel, all_inventory: String(allInv) });
      if (!allInv && start) params.set("start", start);
      if (!allInv && end) params.set("end", end);
      const res = await api.get(`/seller/crosslist/export.csv?${params}`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `shoptosa-${channel}-listings.csv`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-[800px] mx-auto px-6 lg:px-10 pt-28 pb-24" data-testid="seller-export">
      <CrosslistSubnav />
      <PageIntro
        kicker="Crosslist"
        title="Export CSV"
        blurb="Export inventory by date range and column set. Generating is immediate for typical shops."
      />
      <div className="bg-aura-surface border border-aura-border rounded-xl p-6 space-y-5">
        <div>
          <div className="text-sm font-medium mb-2">Filter your inventory</div>
          <label className="flex items-center gap-2 text-sm mb-3">
            <input type="checkbox" checked={allInv} onChange={(e) => setAllInv(e.target.checked)} />
            All inventory
          </label>
          {!allInv && (
            <div className="grid grid-cols-2 gap-3">
              <label className="text-xs text-aura-muted">Start Date<input type="date" value={start} onChange={(e) => setStart(e.target.value)} className="mt-1 w-full px-3 py-2 border border-aura-border rounded-lg bg-aura-surface text-sm" /></label>
              <label className="text-xs text-aura-muted">End Date<input type="date" value={end} onChange={(e) => setEnd(e.target.value)} className="mt-1 w-full px-3 py-2 border border-aura-border rounded-lg bg-aura-surface text-sm" /></label>
            </div>
          )}
        </div>
        <div>
          <div className="text-sm font-medium mb-2">Column headers</div>
          <div className="space-y-2">
            {CHANNELS.map((c) => (
              <label key={c.id} className="flex items-center gap-2 text-sm">
                <input type="radio" name="ch" checked={channel === c.id} onChange={() => setChannel(c.id)} />
                {c.name}
              </label>
            ))}
          </div>
        </div>
        <button type="button" disabled={busy} onClick={generate} className="px-4 py-2.5 bg-aura-accent text-white text-sm rounded-lg" data-testid="export-generate">
          Generate CSV
        </button>
      </div>
    </div>
  );
}
